// 第三方埋点
// 埋点类型
export const TrackType = {
  tencent: 'Tencent',
  byte: 'Byte'
};

// 判断是否是从腾讯埋点过来的，是的话返回部分埋点信息,否的话返回false
// obj是url
export const fromTencent = obj => {
  if (
    Object.prototype.hasOwnProperty.call(obj, 'qz_gdt') ||
    Object.prototype.hasOwnProperty.call(obj, 'gdt_vid')
  ) {
    return {
      type: TrackType.tencent,
      click_id: obj.qz_gdt || obj.gdt_vid
    };
  }
  return false;
};

// 判断是否是从字节埋点过来的，是的话返回部分埋点信息,否的话返回false
// obj是url
export const fromByte = obj => {
  if (
    Object.prototype.hasOwnProperty.call(obj, 'adid') &&
    Object.prototype.hasOwnProperty.call(obj, 'creativeid') &&
    Object.prototype.hasOwnProperty.call(obj, 'creativetype') &&
    Object.prototype.hasOwnProperty.call(obj, 'clickid')
  ) {
    return {
      type: TrackType.byte,
      click_id: obj.clickid
    };
  }
  return false;
};

// 通用：h5,小程序内部跳转
export const fromInner = obj => {
  if (
    Object.prototype.hasOwnProperty.call(obj, 'advChannel') &&
    Object.prototype.hasOwnProperty.call(obj, 'advClickId')
  ) {
    return {
      type: obj.channel,
      click_id: obj.clickId
    };
  }
  return false;
};
// 判断是否是埋点的h5，是的话返回部分埋点信息,否的话返回false
export const formOther = obj => {
  return fromTencent(obj) || fromByte(obj) || fromInner(obj);
};
